import PortalLayout from "@/pages/portal/components/PortalLayout";
import MediaLibrary from "@/components/feature/MediaLibrary";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Owner Portal — Media Library.
 *
 * Business owners get their own Media Library here: the same shared Media
 * Handler block the admin console uses, so they can browse, search, upload and
 * reuse the images stored in the site's uploads folder. Owners can delete the
 * files THEY uploaded — the backend enforces ownership, so no owner can ever
 * remove another business's images.
 */
export default function PortalMediaPage() {
  const { accessToken } = useAuth();

  return (
    <PortalLayout>
      <div className="max-w-6xl">
        <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
          <div>
            <h1 className="font-heading text-2xl font-bold text-foreground-950">Media Library</h1>
            <p className="mt-1 text-sm text-foreground-600">
              Every image you upload lives here — reuse them across your listings instead of uploading
              the same photo twice.
            </p>
          </div>
          <span className="inline-flex shrink-0 items-center gap-2 self-start rounded-full border border-background-300 bg-background-50 px-3 py-1.5 text-xs font-medium text-foreground-600">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-shield-check-line text-sm text-primary-600" />
            </span>
            You can remove your own uploads
          </span>
        </div>

        <div className="mb-5 flex items-start gap-2.5 rounded-lg border border-secondary-200 bg-secondary-50 px-4 py-3 text-xs text-secondary-900">
          <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center">
            <i className="ri-information-line text-sm" />
          </span>
          <span>
            You can delete photos you uploaded yourself. Files added by others can only be removed by
            an admin — the server checks this on every delete.
          </span>
        </div>

        <div className="rounded-xl border border-background-200 bg-background-50 p-5">
          <MediaLibrary
            token={accessToken}
            scope="owner"
            mode="manage"
            canUpload
          />
        </div>
      </div>
    </PortalLayout>
  );
}